import { InputOverrides } from 'baseui/input'
import { borderRadius, borderStyle, borderWidth, padding } from 'polished'
import { LabelM, LabelS } from '../base-typography'
import { useSpace } from '../hooks/use-space'
import { BaseInputProps } from '.'
import { InputStyleArgs, useInputStyle } from './use-input-style'

export const useInputOverrides = ({
  spaceTop,
  spaceBottom,
  onAction,
  action,
  disabled,
  label,
  size = 'l',
}: BaseInputProps) => {
  const {
    getBackgroundColor,
    getBorderColor,
    getPlaceholderColor,
    getActionColor,
    getSize,
    getWithLabelSize,
    getWithLabelActionPostioin,
    getLabelColor,
  } = useInputStyle()
  const { marginTop, marginBottom } = useSpace({ spaceTop, spaceBottom })

  const inputOverrides: InputOverrides = {
    Root: {
      style: (props) => ({
        transitionProperty: 'background-color, border',
        transitionDuration: '0.5s',
        position: 'relative',
        ...getBackgroundColor(props),
        ...getBorderColor(props),
        ...borderWidth('2px'),
        ...borderStyle('solid'),
        ...borderRadius('top', '12px'),
        ...borderRadius('bottom', '12px'),
        ...marginTop,
        ...marginBottom,
        ':hover': {
          ...getBorderColor(props, true),
          ...getBackgroundColor(props, true),
        },
      }),
    },
    InputContainer: {
      style: {
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
      },
    },
    Input: {
      style: (props: InputStyleArgs) => ({
        ...(label ? getWithLabelSize(size) : getSize(size)),
        ...getPlaceholderColor(props),
      }),
    },
    StartEnhancer: {
      style: {
        backgroundColor: 'transparent',
        ...padding('0px'),
      },
    },
    EndEnhancer: {
      style: {
        backgroundColor: 'transparent',
        ...padding('0px'),
      },
    },
    // Action Text
    After: {
      component: (props: any) => (
        <LabelM
          onClick={onAction}
          display="flex"
          position="absolute"
          right="14px"
          {...getActionColor(props)}
          $style={
            label
              ? {
                  cursor: disabled ? 'not-allowed' : 'pointer',
                  zIndex: 2,
                  ...getWithLabelActionPostioin(size),
                }
              : {
                  cursor: Boolean(onAction) ? 'pointer' : 'text',
                  pointerEvents: disabled ? 'none' : 'auto',
                  zIndex: 2,
                }
          }
        >
          {action}
        </LabelM>
      ),
    },
    Before: {
      component: (props: any) => (
        <LabelS
          position="absolute"
          top={size === 'l' ? '6px' : '2px'}
          left="14px"
          {...getLabelColor(props)}
          $style={{
            pointerEvents: 'none',
          }}
        >
          {label}
        </LabelS>
      ),
    },
  }

  return { inputOverrides }
}
